import { render, staticRenderFns } from "./SnackBar.vue?vue&type=template&id=420cd827&scoped=true&"
import script from "./SnackBar.vue?vue&type=script&lang=ts&"
export * from "./SnackBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420cd827",
  null
  
)

export default component.exports